import { request } from '@/utils/request';
import * as url from '@/src/constant';

/**
 * 获取公钥
 * @param query
 * @returns {Promise<TResult>}
 */

export function fetchAksSettings() {
  return request({
    url: url.QUERY_AKS_SETTINGS_URL,
    method: 'GET',
  });
}
